// extracted by mini-css-extract-plugin
export var measureBox = "_4c-0";